module.exports = __webpack_public_path__ + "media/images/shared/icon_search-193f7a901e6ee9b6d1a56df481be5bdf.svg";